const SM = 375;
export const MD = 744;
const MDLG = 1100;
export const LG = 1440;
export const XL = 1920;
export const LIGHT = 300;
export const REGULAR = 400;
export const MEDIUM = 500;
export const BOLD = 600;
export const PHONE = `(min-width: ${SM}px)`;
export const TABLET = `(min-width: ${MD}px)`;
export const LAPTOP = `(min-width: ${MDLG}px)`;
export const DESKTOP = `(min-width: ${LG}px)`;
export const MAX_CONTENT_WIDTH = '678px';
export const MAX_BODY_WIDTH = 1296;
export const COLORS = {
    Primary: '#323232',
    White: '#FFFFFF',
    // Button
    ButtonPrimary: '#FFFFFF',
    ButtonPrimaryHover: '#FFFFFF',
    ButtonPrimaryActive: '#FFFFFF',
    ButtonPrimaryDisabled: '#A3A3A3',
    ButtonSecondary: '#E7E7E733',
    ButtonSecondaryHover: '#E7E7E733',
    ButtonSecondaryActive: '#E7E7E733',
    ButtonSecondaryDisabled: '#F5F5F5',
    ButtonLink: '#525252',
    ButtonLinkHover: '#323232',
    ButtonLinkActive: '#323232',
    ButtonLinkDisabled: '#CDCDCD',
    ButtonDark: '#00000033',
    ButtonDestructive: '#FF4015',
    // Spinner
    GreenSpinner: '#29C236',
    BlueSpinner: '#0324FF',
    WhiteSpinner: '#FFFFFF',
    SpinnerBorder: '#ADADAD7F',
};
export const TextStyle = {
    Body_M: `
        font-size: 0.8125rem;
        line-height: 1.25rem;
        font-weight: 400;
        letter-spacing: 0%;
    `,
    Body_L: `
        font-size: 0.9375rem;
        line-height: 1.375rem;
        font-weight: 400;
        letter-spacing: 0%;
    `,
    Heading_3: `
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
    `,
};
